import { create } from "./create.js";
/** @public */
export const designUnit = create("design-unit").withDefault(4);
/** @public */
export const controlCornerRadius = create("control-corner-radius").withDefault(4);
/** @public */
export const layerCornerRadius = create("layer-corner-radius").withDefault(8);
/** @public */
export const strokeWidth = create("stroke-width").withDefault(1);
/** @public */
export const focusStrokeWidth = create("focus-stroke-width").withDefault(2);
